import React from "react";
import useApi from "../useApi";
import { toast } from "react-toastify";

interface IntakeFormStatusRes {
  msg: string;
  data: {
    canEdit: string;
  };
  status: string;
}

const useFetchIntakeFormStatus = ({ patientId }: { patientId: string }) => {
  const [intakeFormStatus, setIntakeFormStatus] = React.useState<IntakeFormStatusRes>();

  const { loading: intakeFormStatusLoading, makeApiCall } = useApi({
    url: `/rtm/template/intakeform/status/${patientId}`,
    method: "GET",
  });

    const getIntakeFormStatus = React.useCallback(async ({ clearFirst = false } = {}) => {
    if (clearFirst) {
      setIntakeFormStatus(undefined);
    }
    if (!patientId) return;
    const { response, error } = await makeApiCall<undefined, IntakeFormStatusRes>();
    if (response?.status === "success") {
      setIntakeFormStatus(response);
    } else {
      setIntakeFormStatus(undefined);
      toast.error("Something went wrong while fetching intake form status. Please try again later");
    }
  }, [patientId, makeApiCall]);

  return {
    intakeFormStatus,
    getIntakeFormStatus,
    intakeFormStatusLoading,
  };
};

export default useFetchIntakeFormStatus;
